import { createSlice } from '@reduxjs/toolkit';
import { fetchSelfServeCredits } from './thunks';

const initialState = {
	credits: [],
	errorMessage: '',
	isLoading: false,
	metadata: {
		links: {},
		page: 1,
		page_count: 0,
		per_page: 25,
		selfServeCreditSummary: null,
		total_count: 0,
	},
	sorting: {
		direction: null,
		sortBy: null,
	},
};

export const selfServeCreditsSlice = createSlice({
	name: 'selfServeCredits',
	initialState,
	reducers: {
		setSorting: (state, { payload: { direction, sortBy } }) => {
			state.sorting = { direction, sortBy };
		},
	},
	extraReducers: (builder) => {
		builder
			.addCase(fetchSelfServeCredits.pending, (state) => {
				state.isLoading = true;
				state.errorMessage = '';
			})
			.addCase(fetchSelfServeCredits.fulfilled, (state, { payload }) => {
				state.credits = payload.credits;
				state.metadata = payload.metadata;
				state.isLoading = false;
			})
			.addCase(fetchSelfServeCredits.rejected, (state, { meta, payload }) => {
				if (!meta.aborted) {
					state.isLoading = false;
					state.errorMessage = payload || 'Unable to load credits.';
				}
			});
	},
});

export const { setSorting } = selfServeCreditsSlice.actions;

export default selfServeCreditsSlice.reducer;
